import React, { ReactNode } from 'react';
import { Control, Controller, Path } from 'react-hook-form';
import ReactSelect, { Props as SelectProps } from 'react-select';
import classNames from 'classnames';

import { TPickerItem } from '@lootboy/lib/forms/common';

import InputWrapper, {
  IInputWrapperProps,
} from '~/components/atoms/FormControls/InputWrapper';

import { ReactComponent as ChevronDown } from '~/assets/images/iconsLibrary/chevron-left.svg';

import styles from './Select.module.scss';

const SelectIndicatorSeparator = () => null;
const SelectDropdownIndicator = () => (
  <ChevronDown className={styles.chevron} />
);

type TSelectOption<T> = { label: ReactNode; value: T };

type TSelectProps<FormField, SelectValueType> = IInputWrapperProps & {
  control: Control<FormField>;
  name: Path<FormField>;
  id: string;
  placeholder?: string;
  options: Array<TSelectOption<SelectValueType>>;
  selectProps?: SelectProps;
};

export function Select<FormField, SelectValueType>({
  control,
  name,
  label,
  error,
  placeholder,
  options,
  id,
  selectProps,
  errorAction,
}: TSelectProps<FormField, SelectValueType>): React.ReactElement {
  return (
    <InputWrapper
      label={label}
      errorAction={errorAction}
      error={error}
      id={id}
      className={styles.wrapper}
    >
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, onBlur } }) => (
          <ReactSelect
            unstyled
            options={options}
            onChange={onChange}
            onBlur={onBlur}
            value={options.find(
              (option) =>
                option.value ===
                  (value as TPickerItem<SelectValueType>)?.value ?? null,
            )}
            placeholder={placeholder}
            className={classNames(styles.select, !!error && styles.error)}
            classNames={{
              container: (state) =>
                classNames(styles.container, state.isFocused && styles.focused),
              menuList: () => styles.menuList,
              option: (state) =>
                classNames(styles.option, state.isSelected && styles.selected),
              indicatorsContainer: () => styles.indicatorsContainer,
              valueContainer: () => styles.valueContainer,
              menu: () => styles.menu,
            }}
            components={{
              IndicatorSeparator: SelectIndicatorSeparator,
              DropdownIndicator: SelectDropdownIndicator,
            }}
            {...selectProps}
          />
        )}
      />
    </InputWrapper>
  );
}
